import { createContext, useContext, useState } from "react"

interface StudentSelectionContextValue {
  selectedIds: number[]
  setSelectedIds: (ids: number[]) => void
  resetSelection: () => void
  showOnlyWithoutCustomerManager: boolean
  setShowOnlyWithoutCustomerManager: (v: boolean) => void
}

const StudentSelectionContext = createContext<
  StudentSelectionContextValue | undefined
>(undefined)

export function OrganizationStudentSelectionProvider({
  children,
  initialShowOnlyWithoutCustomerManager = false,
}: {
  children: React.ReactNode
  initialShowOnlyWithoutCustomerManager?: boolean
}) {
  const [selectedIds, setSelectedIds] = useState<number[]>([])
  const [showOnlyWithoutCustomerManager, setShowOnlyWithoutCustomerManager] =
    useState<boolean>(initialShowOnlyWithoutCustomerManager)

  function resetSelection() {
    setSelectedIds([])
  }

  return (
    <StudentSelectionContext.Provider
      value={{
        selectedIds,
        setSelectedIds,
        resetSelection,
        showOnlyWithoutCustomerManager,
        setShowOnlyWithoutCustomerManager,
      }}
    >
      {children}
    </StudentSelectionContext.Provider>
  )
}

export function useOrganizationStudentSelection() {
  const ctx = useContext(StudentSelectionContext)
  if (!ctx)
    throw new Error(
      "useOrganizationStudentSelection must be used within OrganizationStudentSelectionProvider",
    )

  return ctx
}
